import { TranslationKey } from "types";

export interface IBuildFeaturesConfigItem {
  description: TranslationKey;
  id: BuildFeatureItemId;
  index?: number;
  isNew: boolean;
  playbackTimeInSeconds: number;
  customWidth?: number;
  src?: string; // TODO: Remove this
  title: string;
  assets?: Array<IBuildFeatureAsset>;
  options?: IBuildFeaturesCustomOptions;
}

export interface IBuildFeaturesProps {
  sections: Array<IBuildFeaturesConfigItem>;
  showImageOnly?: boolean;
  options?: IBuildFeaturesCustomOptions;
}

export interface IBuildFeaturesCustomOptions {
  shouldHideExpandButton?: boolean;
  customCollapsedHeight?: number;
}

export interface IBuildFeatureAsset {
  id: string;
  src: string;
}

export enum BuildFeatureItemId {
  // Dome & Turret
  G6Turret = "g6Turret",
  AiTurret = "aiTurret",
  AiDome = "aiDome",
  G5DomeUltra = "g5DomeUltra",
  G5TurretUltra = "g5TurretUltra",
  G5Dome = "g5Dome",
  Ai360 = "ai360",
  G6Dome = "g6Dome",
  G6180 = "g6180",
  G6Pro360 = "g6Pro360",
  // Bullet
  G6Bullet = "g6Bullet",
  G5Bullet = "g5Bullet",
  G5Pro = "g5Pro",
  AiPro = "aiPro",
  AiDSLR = "aiDSLR",
  AiLPR = "aiLpr",
  // Compact
  G6Instant = "g6Instant",
  G5Flex = "g5Flex",
  G4Instant = "g4Instant",
  // Interior Design
  AiThetaPro = "thetaPro",
  AiTheta = "theta",
  // Special Devices
  AiKey = "aiKey",
  AiPort = "aiPort",
  AIHorn = "aiHorn",
  ProtectViewport = "protectViewport",
  G4DoorbellPro = "g4DoorbellPro",
  // SuperLink
  SuperLink = "superLink",
  AllInOneSensor = "allInOneSensor",
  // Floodlight
  Floodlight = "floodlight",
  // PTZ
  G6Ptz = "g6Ptz",
  AiPtzIndustrial = "aiPtzIndustrial",
  AiPtzPrecision = "aiPtzPrecision",
  G5Ptz = "g5PTZ",
  G4PtzIndustrial = "g4PTZ",
  // Video Recorders
  Envr = "envr",
  NvrPro = "nvrPro",
  Nvr = "nvr",
  CloudKeyPlus = "cloudKeyG2Plus",
  // Door Access
  G3StarterKitPro = "g3StarterKitPro",
  G3StarterKit = "g3StarterKit",
  G2StarterKitPro = "g2StarterKitPro",
  G2StarterKit = "g2StarterKit",
  ElevatorStarterKit = "elevatorStarterKit",
  GateAccessStarterKit = "gateAccessStarterKit",
  EnterpriseAccessHub = "enterpriseAccessHub",
  AccessHub = "accessHub",
  GateHub = "gateHub",
  ElevatorHub = "elevatorHub",
  DoorHub = "doorHub",
  DoorHubMini = "doorHubMini",
  UAUltra = "uaUltra",
  G3ReaderPro = "g3ReaderPro",
  G3ReaderFlex = "g3ReaderFlex",
  G3Reader = "g3Reader",
  G3Intercom = "g3Intercom",
  G2ReaderPro = "g2ReaderPro",
  G2Reader = "g2Reader",
  Intercom = "intercom",
  IntercomViewer = "intercomViewer",
  ReaderLite = "readerLite",
  ElectricLock = "electricLock",
  MagneticLock = "magneticLock",
  // WiFi Enterprise
  E7 = "e7",
  E7Campus = "e7Campus",
  E7Audience = "e7Audience",
  // WiFi Flagship
  U7ProXGS = "u7proXgs",
  U7ProXG = "u7proXg",
  U7ProMax = "u7proMax",
  U7Pro = "u7pro",
  U7LR = "u7LR",
  U7Lite = "u7lite",
  U6Enterprise = "u6Enterprise",
  U6Pro = "u6Pro",
  U6LongRange = "u6LR",
  U6Plus = "u6Plus",
  U6Lite = "u6Lite",
  NanoHD = "nanoHD",
  ACLite = "acLite",
  // WiFi Wall
  U7ProWall = "u7proWall",
  U7InWall = "u7InWall",
  U6EnterpriseInWall = "u6EnterpriseInWall",
  U6InWall = "u6InWall",
  U6Extender = "u6Extender",
  // WiFi Outdoor
  U7ProOutdoor = "u7proOutdoor",
  U7Outdoor = "u7outdoor",
  U6MeshPro = "u6MeshPro",
  U6Mesh = "u6Mesh",
  ACMeshPro = "acMeshProfessional",
  ACMesh = "acMesh",
  SwissArmyKnife = "swissArmyKnifeUltra",
  // WiFi Building Bridge
  BuildingBridgeXG = "buildingBridgeXG",
  BuildingBridge = "buildingBridge",
  DeviceBridge = "udb",
  DeviceBridgePro = "udbPro",
  DeviceBridgeProSector = "udbProSector",
  // Switching Wan
  Wan = "wanSwitch",
  WanRj45 = "wanSwitchRj45",
  // Switching Aggregation
  EnterpriseAggregation = "enterpriseAggregation",
  HighCapacityAggregation = "hiCapacityAggregation",
  Aggregation = "aggregation",
  ProXGAggregation = "proXgAggregation",
  // Switching MultiGbE
  EnterpriseCampus48PoE = "enterpriseCampus48PoE",
  EnterpriseCampus24PoE = "enterpriseCampus24PoE",
  EnterpriseCampus48SPoE = "enterpriseCampus48SPoE",
  EnterpriseCampus24SPoE = "enterpriseCampus24SPoE",
  EnterpriseXG24 = "enterpriseXG24",
  Enterprise48PoE = "enterprise48PoE",
  Enterprise24PoE = "enterprise24PoE",
  ProfessionalMax48PoE = "professionalMax48PoE",
  ProfessionalMax24PoE = "professionalMax24PoE",
  ProfessionalXg48PoE = "professionalXg48PoE",
  ProfessionalXg24PoE = "professionalXg24PoE",
  ProfessionalHd24PoE = "professionalHd24Poe",
  ProfessionalHd24 = "professionalHd24",
  ProfessionalMax16PoE = "professionalMax16PoE",
  ProfessionalMax48 = "professionalMax48",
  ProfessionalMax24 = "professionalMax24",
  ProfessionalMax16 = "professionalMax16",
  ProfessionalXg10PoE = "professionalXg10PoE",
  Professional48PoE = "professional48PoE",
  Professional24PoE = "professional24PoE",
  Professional48 = "professional48",
  Professional24 = "professional24",
  // Switching SingleGbE
  Standard48PoE = "standard48PoE",
  Standard24PoE = "standard24PoE",
  Standard16PoE = "standard16PoE",
  Standard48 = "standard48",
  Standard24 = "standard24",
  // Switching Compact
  ProXg8PoE = "proXg8PoE",
  Enterprise8PoE = "enterprise8PoE",
  Pro8PoE = "professional8PoE",
  Lite16PoE = "lite16PoE",
  Lite8PoE = "lite8PoE",
  SwitchUltra = "switchUltra",
  SwitchUltra60W = "switchUltra60W",
  SwitchUltra210W = "switchUltra210W",
  FlexMini25G = "flexMini2_5G",
  FlexMini = "flexMini",
  Flex10GbE = "flex10GbE",
  Flex25g = "flex2_5G",
  Flex25gPoE = "flex2_5GPoE",
  Flex = "flex",
  // WiFi Mega Capacity
  WiFiBaseStationXG = "baseStationXG",
  // Cloud Gateways Enterprise
  EFG = "efg",
  // Cloud Gateways Large Scale
  UDMProMax = "udmProMax",
  UDMPro = "udmPro",
  UDMSpecialEdition = "udmProSpecial",
  // Cloud Gateways Compact
  UCGMax = "ucgMax",
  UCGUltra = "ucgUltra",
  UCGFiber = "ucgFiber",
  // Cloud Gateways WiFi Integrated
  Express = "express",
  Express7 = "express7",
  UDW = "udw",
  UDR = "udr",
  UDR7 = "udr7",
  // Integrations Network Storage TODO: INTEGRATIONS SHOULD USE ID's FROM MODEL COMPARE FOR FUTURE COMPATIBILITY
  UnasPro = "unasPro",
  // Integrations Digital Signage
  ConnectDisplay = "connectDisplay",
  DisplayCastPro = "displayCastPro",
  DisplayCast = "displayCast",
  // Integrations EV Charging
  EvStationLite = "evStationLite",
  EvStationPro = "evStationPro",
  // Integrations Premium Audio
  UplAmp = "uplAmp",
  // Integrations Managed VoIP
  G3TouchEnterprise = "g3TouchEnterprise",
  G3TouchWall = "g3TouchWall",
  G3TouchPro = "g3TouchPro",
  // Integrations Mobile Routing
  MobileRouterIndustrial = "mobileRouterIndustrial",
  MobileRouterUltra = "mobileRouterUltra",
  MobileRouter = "mobileRouter",
  // Integrations Control Plane Options
  CloudKeyEnterprise = "cloudKeyEnterprise",
  ControlPlaneCloudKeyPlus = "controlPlaneCloudKeyPlus",
  // Integrations Independent Gateways
  GatewayEnterprise = "gatewayEnterprise",
  GatewayPro = "gatewayPro",
  GatewayFiber = "gatewayFiber",
  GatewayMax = "gatewayMax",
  GatewayLite = "gatewayLite",
  // Integrations Internet Solutions
  LteBackup = "lteBackup",
  LteBackupPro = "lteBackupProfessional",
  UCI = "uci",
  // Accessories Power Tech
  MissionCritical = "missionCritical",
  PowerDistributionPro = "powerDistributionPro",
  PowerBackup = "powerBackup",
  // Accessories Rack Designs
  ToollessMiniRack = "toollessMiniRack",
  TwelveURack = "twelveURackCabinet",
  TwelveUSlimRack = "twelveUSlimRackCabinet",
  FortyTwoURack = "fortyTwoURackCabinet",
  NonRackMount = "nonRackMount",
  PoeIntegratedAcAdapter = "poeIntegratedAcAdapter",
}
